import { render, staticRenderFns } from "./ThresholdValueList.vue?vue&type=template&id=f23c28d8&scoped=true&"
import script from "./ThresholdValueList.vue?vue&type=script&lang=js&"
export * from "./ThresholdValueList.vue?vue&type=script&lang=js&"
import style1 from "./ThresholdValueList.vue?vue&type=style&index=1&id=f23c28d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23c28d8",
  null
  
)

export default component.exports